<script>
  import { onMount, setContext } from "svelte";  
  import Dropdown from "./components/Dropdown.svelte";
  import DropdownItem from "./components/DropdownItem.svelte";
  import { CollapsibleMenu, TextInput } from "paxray-components-svelte";

  import Modal from "lib/components/Modal.svelte";

  import FolderIcon from "./components/svg/FolderIcon.svelte";
  import RightArrowIcon from "./components/svg/RightArrowIcon.svelte";
  import ProcessIcon from "./components/svg/ProcessIcon.svelte";

  import { jwtDecode } from "jwt-decode";
  import { Session } from "svelte-session-manager";
  import ProcessModeler from "./components/ProcessModeler.svelte";
  import ProcessHierarchy from "./components/ProcessHierarchy.svelte";
  import TreeView from "./components/TreeView/TreeView.svelte";
  import Button from "lib/components/Button.svelte";

  import { navigate } from "svelte-navigator";
  import { openedPage } from "lib/stores.js";
  import { sortedAccessRights } from "lib/stores.js";
  import ProcessInformation from "./components/ProcessInformation.svelte";

  import MultiSelect from "lib/components/MultiSelect.svelte";
  import Header from "lib/components/Header.svelte";

  import ContentSwitcher from "lib/components/ContentSwitcher.svelte";

  import { fetchWithSession } from "lib/util/fetchWithSession.js";

  let urlParams = new URLSearchParams(window.location.search);
  let idprocess = urlParams.get("idprocess");
  let folderid = urlParams.get("folderid");

  let session = new Session(localStorage);

  let processid;
  let subprocessid;
  let treeview;
  let unsafedChanges;

  let saveAction;
  let uploadAction;
  let downloadAction;
  let users;
  let teams;
  let filteredTeams;
  let filteredUsers;
  let selectedTeams;
  let selectedUsers;
  const decoded = jwtDecode(session.authorizationHeader.Authorization || "");

  $: infoView = $openedPage;
  $: titleName = $sortedAccessRights[idprocess]?.text;
  $: selectedItemType = $sortedAccessRights[idprocess]?.type;
  let payloadAccessRights = {
    add_team: [],
    remove_team: [],
    add_user: [],
    remove_user: [],
  };

  let selectedNode = {};
  let selectedAction = "new";
  let openDeleteModal = false;

  setContext("TreeViewTest", {
    onContextMenuChange: ({ node, event, type, action }) => {
      selectedNode = { ...node, type: type };
    },
    selectedAction: ({ action }) => {
      selectedAction = action;
    },
  });

  onMount(() => {
    idprocess = urlParams.get("idprocess");
    // fetchInitialData();
    processFolders();
  });

  function processFolders() {
    fetchWithSession(`/api/pman/processFolders`)
      .then((response) => response.json())
      .then((data) => {
        children = data;
        expandFolderTree(children);
        children = children;
        openFolderOrProcess(idprocess);
        expandTreeElements(idprocess);
        fetchInitialData();
      });
  }

  const fetchInitialData = () => {
    fetchWithSession(`/api/authentication/settings/teams`)
      .then((response) => response.json())
      .then((data) => {
        teams = data.data.map((d) => {
          return {
            id: d.id,
            text: d.name,
          };
        });
        filteredTeams = teams;
        users = data.available_users.map((d) => {
          return { id: d.id, text: d.username };
        });
        filteredUsers = users;
        selectedTeams = $sortedAccessRights[idprocess]?.access_right.team_ids;
        selectedUsers = $sortedAccessRights[idprocess]?.access_right.user_ids;
        if ($sortedAccessRights[idprocess]?.parentid) {
          filteredTeams = teams.filter((d) =>
            $sortedAccessRights[
              idprocess
            ]?.parent_access_right.team_ids.includes(d.id),
          );
          filteredUsers = users.filter((d) =>
            $sortedAccessRights[
              idprocess
            ]?.parent_access_right.user_ids.includes(d.id),
          );
        }
      });
  };

  const updateAccessRights = () => {
    openShareModal = false;
    fetchWithSession(`/api/pman/saveProcessModel`, {
      method: "POST",
      body: JSON.stringify({
        id: processid,
        name: titleName,
        ...payloadAccessRights,
      }),
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.status == "success") {
          processFolders();
          updateURL(processid);
        }
      });
  };

  const deletedItem = () => {
    openDeleteModal = false;
    fetchWithSession(
      `/api/pman/${
        selectedNode.type === "process"
          ? "deleteProcessModel"
          : "deleteProcessFolder"
      }`,
      {
        method: "POST",
        body: JSON.stringify({
          id: selectedNode.id,
        }),
      },
    )
      .then((response) => response.json())
      .then((res) => {
        // fetchProcessFolders();
        processFolders();
      });
  };

  const newTeamChanges = (event) => {
    const newTeams = event.detail.selected.map((d) => d.id);
    const previousTeams = selectedTeams || [];
    payloadAccessRights.add_team = newTeams.filter(
      (d) => !previousTeams.includes(d),
    );
    payloadAccessRights.remove_team = previousTeams.filter(
      (d) => !newTeams.includes(d),
    );
  };

  const newUserChanges = (event) => {
    const newUsers = event.detail.selected.map((d) => d.id);
    const previousUsers = selectedUsers || [];
    payloadAccessRights.add_user = newUsers.filter(
      (d) => !previousUsers.includes(d),
    );
    payloadAccessRights.remove_user = previousUsers.filter(
      (d) => !newUsers.includes(d),
    );
  };

  function expandFolderTree(treeRoot, id = "", type = "folder") {
    treeRoot.forEach((element) => {
      if (element.type == "folder") element.icon = FolderIcon;
      else element.icon = ProcessIcon;
      expandFolderTree(element.children, element.id, element.type);
    });
    // if (type == "folder" && id) {
    //   treeRoot.push({
    //     icon: PlusIcon,
    //     text: "Add New",
    //     id: "new:" + id,
    //   });
    // }
    return null;
  }

  function expandTreeElements(id) {
    let element = searchTree(children, id);
    while (element && element.id) {
      if (!expandedIds.includes(element.id)) expandedIds.push(element.id);
      element = searchTree(children, element.parentid || element.folderid);
    }
    expandedIds = expandedIds;
  }

  function searchTree(root, searchid) {
    let process;
    root.forEach((element) => {
      if (!process) {
        if (element.id == searchid) process = element;
        else if (element.children)
          process = searchTree(element.children, searchid);
      }
    });
    return process;
  }

  let activeId = 0;
  let selectedIds = [];
  let children = [];
  let newItemModalVisible = false;
  let openShareModal = false;
  let newParentId = "";
  let isNewProcess = 0;
  let newProcessName = "";
  let newFolderName = "";
  let newFolderDescription = "";
  let currentItem = { children: [] };
  let expandedIds = [];
  let expandTreeSideBar = true;

  $: {
    if (unsafedChanges) {
      window.onbeforeunload = function (e) {
        e.preventDefault();
        e.returnValue = true;
        return true;
      };
    } else {
      window.onbeforeunload = null;
    }
  }

  function openFolderOrProcess(id) {
    if (unsafedChanges) {
      if (
        !window.confirm(
          "You have unsaved changes! Do you really want to leave?",
        )
      )
        return;
      else {
        unsafedChanges = false;
      }
    }
    if (!id) return;
    let processcompoments = id.split(":::::");
    if (processcompoments[1]) {
      subprocessid = processcompoments[1];
      processid = processcompoments[0];
    } else {
      processid = "";
      subprocessid = "";
    }

    let components = id.split(":");
    if (components[0] == "new") {
      folderid = components[1];
      newProcessName = "";
      newFolderDescription = "";
      newFolderName = "";
      newParentId = components[1] || null;
      currentItem = searchTree(children, components[1]) || children;
      isNewProcess = 0;
      if (selectedAction === "new") {
        newItemModalVisible = true;
      } else {
        openDeleteModal = true;
      }
    } else {
      updateURL(id);
      currentItem = searchTree(children, id);
      if (currentItem && currentItem.type == "process") {
        processid = processid || id;
        folderid = null;
      } else {
        folderid = id;
        processid = null;
      }
    }
  }

  function createProcessOrFolder() {
    if (isNewProcess) {
      if (!newProcessName) {
        processNameInvalid = true;
        return;
      }
      processNameInvalid = false;

      fetchWithSession(`/api/pman/saveProcessModel`, {
        method: "POST",
        body: JSON.stringify({
          name: newProcessName,
          folderid: newParentId,
        }),
      })
        .then((response) => response.json())
        .then((res) => {
          if (res.status == "success") {
            let process = res.process;
            process.text = process.name;
            process.icon = ProcessIcon;
            process.type = "process";
            process.children = [];

            let currentChildren = Array.isArray(currentItem.children)
              ? currentItem.children
              : children;
            currentChildren.push(process);
            children = children;
            processid = process.id;
            idprocess = processid;
            activeId = processid;
            folderid = "";
            openFolderOrProcess(processid);

            newItemModalVisible = false;
          }
        });
    } else {
      if (!newFolderName) {
        folderNameInvalid = true;
        return;
      }
      folderNameInvalid = false;

      fetchWithSession(`/api/pman/addProcessFolder`, {
        method: "POST",
        body: JSON.stringify({
          name: newFolderName,
          description: newFolderDescription,
          parentid: newParentId ? newParentId : "",
        }),
      })
        .then((response) => response.json())
        .then((res) => {
          if (res.status == "success") {
            let folder = res.folder;
            folder.text = folder.name;
            folder.type = "folder";
            folder.icon = FolderIcon;
            folder.children = [];

            let currentChildren = Array.isArray(currentItem.children)
              ? currentItem.children
              : children;
            currentChildren.push(folder);

            folderid = folder.id;
            children = children;
            newItemModalVisible = false;
          }
        });
    }
  }

  function updateURL(id = "") {
    urlParams.set("idprocess", id);
    if ($sortedAccessRights[id]?.text) {
      titleName = $sortedAccessRights[id]?.text;
      selectedItemType = $sortedAccessRights[id]?.type;
    }
    filteredTeams = teams;
    filteredUsers = users;
    selectedTeams = $sortedAccessRights[id]?.access_right.team_ids;
    selectedUsers = $sortedAccessRights[id]?.access_right.user_ids;
    if ($sortedAccessRights[id]?.parentid) {
      filteredTeams = teams.filter((d) =>
        $sortedAccessRights[id]?.parent_access_right.team_ids.includes(d.id),
      );
      filteredUsers = users.filter((d) =>
        $sortedAccessRights[id]?.parent_access_right.user_ids.includes(d.id),
      );
    }
    window.history.pushState("page2", "Title", `?${urlParams.toString()}`);
  }

  $: {
    if (folderid == "Landscape") folderid = "";
    if (folderid) {
      if (!expandedIds.includes(folderid) && activeId != folderid) {
        expandTreeElements(folderid);
      }
      activeId = folderid;
      children = children;
      openFolderOrProcess(folderid);
    }
  }

  const handleToggleSideBar = () => {
    if (expandTreeSideBar) {
      expandTreeSideBar = false;
    } else {
      expandTreeSideBar = true;
    }
  };

  let processNameInvalid = false;
  let folderNameInvalid = false;

</script>

<div class="header-container">
  <Header section="Process Modeler" breadcrumb={titleName || ""}>
    {#if decoded.role !== "viewer"}
      {#if selectedItemType === "process"}
        <Button
          on:click={() => {
            openShareModal = true;
          }}
          text="Share"
          icon="share"
          variant="secondary"
          iconLeft={true}
          setting={true}
        />
      {/if}
      {#if infoView !== true}
        <Button
          on:click={uploadAction}
          text="Upload"
          icon="upload"
          variant="secondary"
          iconLeft={true}
          setting={true}
        />
        <div class="parent-container">
          <Dropdown
            text="Download"
            variant="secondary"
            icon="download"
            iconLeft={true}
          >
            <DropdownItem
              on:select={() => downloadAction("bpmn")}
              text="BPMN"
            />
            <DropdownItem on:select={() => downloadAction("pdf")} text="PDF" />
            <DropdownItem on:select={() => downloadAction("svg")} text="SVG" />
            <!-- @Vladi add a print function, please -->
            <DropdownItem
              on:select={() => downloadAction("print")}
              text="Print"
            />
          </Dropdown>
        </div>
        <Button
          on:click={saveAction}
          text="Save"
          icon="save"
          variant="secondary"
          iconLeft={true}
          setting={true}
        />
      {/if}
      {#if infoView === true}
        <!-- @Adrian hier noch keine Funktion -->
        <!-- <ButtonNew
          text="Edit"
          icon="edit"
          disabled={true}
          variant="secondary"
          iconLeft={true}
          setting={true}
        /> -->
      {/if}
    {/if}

    <Button
      on:click={() => {
        if (infoView) {
          openedPage.set(false);
        } else {
          navigate("/");
        }
      }}
      text="Back"
      icon="arrow_left"
      variant="secondary"
      iconLeft={true}
      setting={true}
    />
  </Header>
</div>

<div style="display: flex; height: 100%;">
  <CollapsibleMenu label="Process Selection">
    <TreeView
      bind:children
      bind:expandedIds
      bind:activeId
      bind:selectedIds
      bind:this={treeview}
      on:select={({ detail }) => {
        openFolderOrProcess(detail.id);
      }}
      {sortedAccessRights}
    />
  </CollapsibleMenu>

  <div style="display:{infoView ? 'flex' : 'none'}">
    <ProcessInformation />
  </div>

  <div class="containerClass" style="display:{infoView ? 'none' : ''}">
    {#if processid}
      <ProcessModeler
        {processid}
        bind:children
        bind:subprocessid
        bind:processStructure={currentItem.children}
        bind:saveAction
        bind:uploadAction
        bind:downloadAction
        bind:expandTreeSideBar
        bind:unsafedChanges
        decodedData={decoded}
      />
    {:else}
      <ProcessHierarchy
        bind:downloadAction
        bind:uploadAction
        bind:saveAction
        bind:expandTreeSideBar
        bind:folderid
        bind:children
        bind:unsafedChanges
      />
      <!-- {:else}
        <ProcessLandscape bind:idprocess={folderid} bind:children={children}></ProcessLandscape> -->
    {/if}
  </div>
</div>

<Modal
  actions
  autowidth={true}
  open={newItemModalVisible}
  modalHeading="Create new Process / Folder"
  primaryButtonText="Create"
  secondaryButtonText="Cancel"
  primaryButtonAction={() => {
    newItemModalVisible = false;
    createProcessOrFolder();
  }}
  on:open
  on:close={() => {
    newItemModalVisible = false;
  }}
>
  <ContentSwitcher
    options={["Folder", "Process"]}
    bind:selected={isNewProcess}
  />

  {#if isNewProcess === 1}
    <TextInput
      labelText="Process Name"
      bind:value={newProcessName}
      invalid={processNameInvalid && !newProcessName}
    />
  {:else}
    <TextInput
      labelText="Folder Name"
      bind:value={newFolderName}
      invalid={folderNameInvalid && !newFolderName}
    />
    <TextInput labelText="Description" bind:value={newFolderDescription} />
  {/if}
</Modal>

<Modal
  open={openShareModal}
  actions
  size="lg"
  autowidth={true}
  modalHeading="Share Process"
  primaryButtonText="Share Process"
  width={653}
  on:close={() => {
    openShareModal = false;
  }}
  primaryButtonAction={updateAccessRights}
>
  <div>
    <MultiSelect
      selectedIds={selectedUsers || []}
      items={filteredUsers}
      labelText="Users"
      onchange={newUserChanges}
    />
    <MultiSelect
      selectedIds={selectedTeams || []}
      items={filteredTeams}
      labelText="Teams"
      onchange={newTeamChanges}
    />
  </div>
</Modal>

<Modal
  open={openDeleteModal}
  actions
  size="lg"
  modalHeading="Delete Folder/Process"
  primaryButtonText="Delete"
  width={653}
  on:close={() => {
    openDeleteModal = false;
  }}
  primaryButtonAction={deletedItem}
>
  <div>Confirm delete Process/Folder</div>
</Modal>

<style>
  :global(.tree-bar-container) {
    width: 35px;
    position: relative;
    height: calc(100vh - 4rem);
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    background-color: white;
    cursor: pointer;
  }

  :global(.process-section) {
    transform: rotate(270deg);
    position: absolute;
    width: max-content;
    top: 50%;
    font-size: 0.8rem;
  }

  :global(.containerClass > div) {
    display: flex;
  }

  .containerClass {
    flex-grow: 1;
  }

  .parent-container {
    position: relative;
    z-index: 10000;
  }

  .header-container {
    position: relative;
    z-index: 10000;
  }
</style>
